import { authStore } from '@/store/authStore';
import { userStore } from '@/store/user/store';
import { useMutateData } from '@/utils/ReqUtil';
import { XMarkIcon } from '@heroicons/react/24/outline';

interface StopImpersonatingResponseData {
  data: {
    message: string;
  };
  redirect_to?: string;
}

const ImpersonationBanner = () => {
  const { user } = userStore();
  const { impersonating } = authStore();

  const { mutate } = useMutateData('POST', '/users/stop_impersonating');

  const handleLogout = () => {
    mutate(
      {},
      {
        onSuccess: (resData) => {
          const { redirect_to } = resData as StopImpersonatingResponseData;
          if (!redirect_to) return;

          localStorage.clear();

          window.location.href = redirect_to;
        },
        onError: () => {
          console.error('Failed to logout!');
        },
      },
    );
  };

  return (
    <>
      {impersonating && (
        <div className="text-xs-body bg-[#ffcc0d] text-center py-2">
          You are currently logged in as {user.firstName} {user.lastName}.{' '}
          <span
            className="text-body-sm hover:text-primary underline cursor-pointer inline-flex items-center gap-1"
            onClick={handleLogout}
          >
            Click here to logout
            <XMarkIcon data-testid="x-mark-icon" className="w-[18px] h-[18px] stroke-[3]" />
          </span>
        </div>
      )}
    </>
  );
};

export default ImpersonationBanner;
